/**
 * AIチャット（クリフォアAI）
 * 公式サイト(clinic-for-wp-theme) assets/js/ai_chat.js を移植。
 * 公式との差分を追いやすくするため、公式のコードをベースに必要な箇所だけ変更している。
 * CFB で変更した箇所には「CFB:」コメントを付ける。
 *
 * 必ず snippets/ai-chat.liquid から読み込むこと。petite-vue はスニペット側で先に読み込んでいる。
 * API の接続先は、公式の PHP のグローバル変数の代わりに .js-ai-chat の data-http-endpoint / data-websocket-endpoint で受け取る。
 * device_id は公式どおり amplitude.getDeviceId() を使う（Amplitude は snippets/amplitude-tag.liquid で読み込み・初期化している）。
 * Amplitude のイベント送信も公式どおり有効化している。
 */
var LINCWELL = LINCWELL || {};
LINCWELL.AI_CHAT = LINCWELL.AI_CHAT || {};
LINCWELL.AI_CHAT = function () {
  this.init();
};
LINCWELL.AI_CHAT.prototype = {
  AI_CHAT_TARGET: '.js-ai-chat',
  INITIAL_AI_MESSAGE: 'こんにちは、AIがCLINIC FOR BEAUTYについてお答えします。',
  REVIEW_SUCCESS_MESSAGE: '評価ありがとうございます',
  BALLOON_SHOW_TIME: 1000 * 1, // CFB: 公式LPと同じ1秒
  BALLOON_HIDE_TIME: 3000, // 3秒
  CONFIRM_STORAGE_KEY: 'AI_USAGE_CONFIRMED',
  HTTP_ENDPOINT: '', // CFB: createApp() で data-http-endpoint から設定する
  WEBSOCKET_ENDPOINT: '', // CFB: createApp() で data-websocket-endpoint から設定する
  init() {
    // CFB: petite-vue はスニペットで先に読み込むため setPetiteVue() は使わない
    this.bindEvent();
  },
  bindEvent() {
    this.createApp();
    this.setBalloonTimer();
  },
  async createApp() {
    const target = document.querySelector(this.AI_CHAT_TARGET);
    if (!target) return;
    if (typeof amplitude !== 'object') {
      console.warn('Amplitude is not loaded or not initialized.');
      return;
    }
    // CFB: 接続先はスニペットの data-* 属性から受け取る（StreamClient / ApiClient から参照するため prototype に設定）
    LINCWELL.AI_CHAT.prototype.HTTP_ENDPOINT = target.dataset.httpEndpoint;
    LINCWELL.AI_CHAT.prototype.WEBSOCKET_ENDPOINT = target.dataset.websocketEndpoint;
    const data = await this.vueData().then((data) => data);
    const interval = setInterval(() => {
      const deviceId = amplitude.getDeviceId();
      if (typeof PetiteVue === 'object' && deviceId) {
        data.deviceId = deviceId;
        PetiteVue.createApp(data).mount(target);
        clearInterval(interval);
      }
    }, 100);
  },
  generateUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID()
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0
      const v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  },
  amplitudeEvent({ eventName, args }) {
    if (typeof amplitude !== 'object' || typeof amplitude.track !== 'function') return;
    const params = {
      'Page URL': `${location.origin}${location.pathname}`,
      'Page Location': location.href,
    };
    Object.keys(args || {}).forEach(key => {
      params[key] = args[key];
    });
    amplitude.track(eventName, params);
  },
  createLabel(appLabel, inputValue = '') {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0') // 月は0から始まるので+1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const formattedDateTime = `${year}${month}${day}-${hours}${minutes}${seconds}`;

    return `${appLabel}.${formattedDateTime}.${this.randomString(4)}.${inputValue.substring(0, 8)}`;
  },
  randomString(length) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let result = ''
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    return result
  },
  // CFB: AI の回答は v-html で表示するため、HTML として解釈されないようエスケープする
  escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  },
  // CFB: CFB 用の url_table.js がないため、文言は常に「URLリンク」にする。
  //      公式は url_table.js で URL ごとに文言を決めている（表にない URL は「URLリンク」）。CFB でも公式を踏襲して採用する可能性がある
  //      バックエンドは URL の直後に空白や改行を入れて返す前提のため、公式と同じく空白か ) までを URL とみなす
  replaceUrlsWithLinks(text) {
    return text.replace(/https?:\/\/[^\s)]+/g, url => {
      return `<a href="${url}" target="_blank" class="ai-chat-modal__message-link js-chatbot-link-reference">URLリンク</a>`;
    })
  },
  getURLs(content) {
    return content.match(/https?:\/\/[^\s"'<>]+/g) || [];
  },
  withTimeout(promise, timeoutMs) {
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('Operation timed out')), timeoutMs);
    })
    return Promise.race([promise, timeoutPromise]);
  },
  async waitOpen(socket) {
    await this.withTimeout(
      new Promise((resolve, reject) => {
        socket.onopen = resolve;
        socket.onerror = reject;
      }),
      10000
    );
  },
  nextMessage(socket) {
    return this.withTimeout(
      new Promise((resolve, reject) => {
        socket.onmessage = event => resolve(event);
        socket.onerror = reject;
        socket.onclose = () => reject(new Error('WebSocket connection closed'));
      }),
      60000 // 60秒のメッセージタイムアウト
    );
  },
  handleWebSocketStream: async function* (url, payload, MAX_MESSAGES = 1000) {
    const socket = new WebSocket(url);

    try {
      await this.waitOpen(socket);
      socket.send(JSON.stringify(payload));

      let messageCount = 0;

      while (true) {
        if (messageCount >= MAX_MESSAGES) {
          throw new Error('Maximum message count exceeded');
        }
        const event = await this.nextMessage(socket);
        const data = JSON.parse(event.data);
        if (data.error) {
          throw new Error(data.error);
        }
        if (data.message) {
          messageCount++;
          yield data.message;
        }
        if (data.done) {
          break;
        }
      }
    } catch (error) {
      throw error;
    } finally {
      socket.close();
    }
  },
  StreamClient: class {
    constructor(sessionId) {
      this.endpoint = LINCWELL.AI_CHAT.prototype.WEBSOCKET_ENDPOINT; // CFB
      this.sessionId = sessionId;
    }

    // CFB: CFB 用のエンドポイントを使い、送信するのは prompt だけ（model_name / device_id / kwargs はサーバー側で決める）
    async *streamMultiFlowChat(prompt) {
      const url = this.endpoint + `/ws/chat/stream_cfb/${this.sessionId}`;
      const payload = { prompt };
      yield* LINCWELL.AI_CHAT.prototype.handleWebSocketStream(url, payload);
    }
  },
  ApiClient: class {
    constructor(sessionId, streamClient) {
      this.endpoint = LINCWELL.AI_CHAT.prototype.HTTP_ENDPOINT; // CFB
      this.sessionId = sessionId;
      this.streamClient = streamClient;
    }

    async createSession(device_id, initial_ai_message, label) {
      const url = this.endpoint + '/chat/create';
      const payload = {
        session_id: this.sessionId,
        device_id,
        initial_ai_message,
        label
      };
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'include'
      });
      return await res.json();
    }

    async updateStatus(device_id, kind, data) {
      const url = this.endpoint + `/chat/update_status/${this.sessionId}`;
      const payload = { device_id, kind, data };
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'include'
      });
      return await res.json();
    }

    // CFB: CFB の message は { content, stop } だけで agent を含まないため、agent による絞り込みはしない
    async *streamMultiFlowChat(prompt) {
      yield* this.streamClient.streamMultiFlowChat(prompt);
    }
  },
  // CFB: 公式LP（TARGET = 'LP'）の挙動に固定し、公式サイト向けのマウス操作で吹き出しを出し直す処理は削除
  setBalloonTimer() {
    const balloon = document.querySelector('.js-ai-chat-balloon');
    if (!balloon) return;
    const _self = this;
    let balloonTimer;
    window.addEventListener('load', setShowTimer); // CFB: 他のスクリプトの window.onload を上書きしない

    function setHideTimer() {
      clearTimeout(balloonTimer);
      balloonTimer = setTimeout(() => {
        balloon.classList.remove('is-show');
      }, _self.BALLOON_HIDE_TIME);
    };

    function setShowTimer() {
      clearTimeout(balloonTimer);
      balloonTimer = setTimeout(() => {
        balloon.classList.add('is-show');
        _self.amplitudeEvent({
          eventName: 'Activate AI Chatbot Balloon',
          args: {
            'Page Path': location.pathname,
          }
        });
        setHideTimer();
        document.querySelector('.js-ai-chat-modal-trigger').classList.add('is-show');
      }, _self.BALLOON_SHOW_TIME);
    };
  },
  async vueData() {
    const _self = this;
    const html = document.documentElement; // CFB: スクロール停止は html.ai-chat-is-open（公式は body.is-fixed）
    const bottomElement = document.querySelector('.js-ai-chat-modal-bottom-element');
    const triggerElement = document.querySelector('.js-ai-chat-modal-trigger');
    if (!triggerElement || !bottomElement) return;
    const initialMessage = {
      id: _self.generateUUID(),
      role: 'assistant',
      content: this.INITIAL_AI_MESSAGE,
      date: new Date(),
    };
    return {
      initialMessage,
      client: null,
      isConfirm: false,
      isModalOpen: false,
      status: 'ready',
      messages: [initialMessage],
      inputMessage: '',
      deviceId: null,
      isLoading: false,
      sessionId: _self.generateUUID(),
      streamingContent: '',
      review: 'none',
      isSubmittingReview: false,
      // CFB: アイコンの URL は asset_url で決まるため、getGoodIcon() / getBadIcon() は使わずスニペット側で切り替える
      init() {
        triggerElement.addEventListener('click', () => {
          this.setModalOpen();
        });
        this.setClickReferenceEvent();
        if (sessionStorage.getItem(_self.CONFIRM_STORAGE_KEY) === 'true') {
          this.isConfirm = true;
        }
      },
      setConfirm() {
        sessionStorage.setItem(_self.CONFIRM_STORAGE_KEY, 'true');
        this.isConfirm = true;
      },
      setModalClose() {
        html.classList.remove('ai-chat-is-open');
        this.isModalOpen = false;
        this.inputMessage = '';
      },
      setModalOpen() {
        html.classList.add('ai-chat-is-open');
        this.isModalOpen = true;
        this.inputMessage = '';
        _self.amplitudeEvent({
          eventName: 'Open AI Chatbot',
          args: {
            'Page Path': location.pathname,
          }
        });
      },
      setClickReferenceEvent() {
        document.querySelectorAll('.js-chatbot-link-reference').forEach(element => {
          if (element.dataset.amplitudeEventBind) return;
          element.dataset.amplitudeEventBind = 'true';
          element.addEventListener('click', () => this.handleClickReferenceEvent(element));
        });
      },
      handleClickReferenceEvent(element) {
        _self.amplitudeEvent({
          eventName: 'Click Reference Link in AI Chatbot',
          args: {
            'Page Path': location.pathname,
            'session_id': this.sessionId,
            'Reference URL': element.href,
          }
        });
      },
      async sendMessage() {
        if (!this.inputMessage.trim() || this.status !== 'ready') return;
        this.review = 'none';
        const sendId = _self.generateUUID();
        this.status = 'submitted';
        this.isLoading = true;
        this.messages.push({
          id: sendId,
          role: 'user',
          content: this.inputMessage,
          date: new Date(),
        });
        await this.scrollToBottom();
        this.sessionId = this.client?.sessionId ?? _self.generateUUID();
        this.streamingContent = '';

        _self.amplitudeEvent({
          eventName: 'Send Question to AI Chatbot',
          args: {
            'Page Path': location.pathname,
            'session_id': this.sessionId,
          }
        });

        try {
          if (this.client == null) {
            const streamClient = new _self.StreamClient(this.sessionId);
            const client = new _self.ApiClient(this.sessionId, streamClient);
            const initialMessage = this.initialMessage['content'];
            const label = _self.createLabel('cfb', this.inputMessage); // CFB: TODO: サーバー側で CFB の会話を区別する方法（CFB 向けのチャットを使う方法）を確認する。現在は仮で 'cfb'
            await client.createSession(this.deviceId, initialMessage, label);
            this.client = client;
          }

          let responseContent = '';
          this.status = 'streaming';

          const streamMessageId = _self.generateUUID();
          for await (const message of this.client.streamMultiFlowChat(this.inputMessage)) { // CFB: 送信するのは prompt だけ
            const lastMessage = this.messages[this.messages.length - 1];
            responseContent = responseContent + message.content // CFB: cancel が来ないため、本文を消す処理はしない
            this.streamingContent = responseContent;
            if (lastMessage.id === streamMessageId) {
              lastMessage.content = _self.escapeHtml(responseContent); // CFB
            } else {
              this.isLoading = false;
              this.messages.push({
                id: streamMessageId,
                role: 'assistant',
                content: _self.escapeHtml(responseContent), // CFB
                date: new Date(),
              });
            }
          }
          await this.scrollToBottom();

          this.inputMessage = '';

          this.messages[this.messages.length - 1].content = _self.replaceUrlsWithLinks(_self.escapeHtml(responseContent)); // CFB: エスケープしてからリンクにする

          _self.amplitudeEvent({
            eventName: 'Receive Reply from AI Chatbot',
            args: {
              'Page Path': location.pathname,
              'session_id': this.sessionId,
              'Reply Message' : responseContent,
              'attached URL': _self.getURLs(responseContent),
            }
          });
        } catch (e) {
          console.error('AIチャットの応答取得中にエラーが発生しました。', e); // CFB: 原因を追えるようにする
          this.messages.push({
            id: _self.generateUUID(),
            role: 'assistant',
            content: '申し訳ございません。サーバーとの接続に問題が発生しています。\n大変お手数をおかけしますが、再度お試しください。続けて発生する場合は、<a href="/pages/contact#contact_form" target="_blank" class="ai-chat-modal__note-link js-chatbot-link-reference"><span class="ai-chat-modal__note-link-inner">お問い合わせフォーム<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 5.75C5.66848 5.75 5.35054 5.8817 5.11612 6.11612C4.8817 6.35054 4.75 6.66848 4.75 7V18C4.75 18.3315 4.8817 18.6495 5.11612 18.8839C5.35054 19.1183 5.66848 19.25 6 19.25H17C17.3315 19.25 17.6495 19.1183 17.8839 18.8839C18.1183 18.6495 18.25 18.3315 18.25 18V12C18.25 11.5858 18.5858 11.25 19 11.25C19.4142 11.25 19.75 11.5858 19.75 12V18C19.75 18.7293 19.4603 19.4288 18.9445 19.9445C18.4288 20.4603 17.7293 20.75 17 20.75H6C5.27065 20.75 4.57118 20.4603 4.05546 19.9445C3.53973 19.4288 3.25 18.7293 3.25 18V7C3.25 6.27065 3.53973 5.57118 4.05546 5.05546C4.57118 4.53973 5.27065 4.25 6 4.25H12C12.4142 4.25 12.75 4.58579 12.75 5C12.75 5.41421 12.4142 5.75 12 5.75H6Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15.25 2C15.25 1.58579 15.5858 1.25 16 1.25H22C22.4142 1.25 22.75 1.58579 22.75 2V8C22.75 8.41421 22.4142 8.75 22 8.75C21.5858 8.75 21.25 8.41421 21.25 8V2.75H16C15.5858 2.75 15.25 2.41421 15.25 2Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M22.5303 1.46967C22.8232 1.76256 22.8232 2.23744 22.5303 2.53033L11.5303 13.5303C11.2374 13.8232 10.7626 13.8232 10.4697 13.5303C10.1768 13.2374 10.1768 12.7626 10.4697 12.4697L21.4697 1.46967C21.7626 1.17678 22.2374 1.17678 22.5303 1.46967Z" fill="currentColor"></path></svg></span></a>からご連絡ください。', // CFB: 回答の下にあった問い合わせフォームへの案内を削除したため、メッセージ内にリンクを入れる
            date: new Date(),
          });
          this.isLoading = false;
          this.inputMessage = '';
        } finally {
          this.status = 'ready';
        }
        setTimeout(() => {
          this.setClickReferenceEvent();
        }, 0);
      },
      scrollToBottom() {
        return new Promise((resolve) => {
          if (bottomElement) {
            setTimeout(() => {
              bottomElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
              resolve();
            }, 100);
          } else {
            resolve();
          }
        });
      },
      async handleReviewSelect(selectedReview) {
        if (!this.client || this.isSubmittingReview || this.review === selectedReview) return;
        this.isSubmittingReview = true;
        try {
          const result = await this.client.updateStatus(this.deviceId, 'review', selectedReview);
          if (result.content === _self.REVIEW_SUCCESS_MESSAGE) {
            this.review = selectedReview;
          } else {
            console.error('AIチャットのフィードバック保存に失敗しました。', result.content);
          }
        } catch (e) {
          console.error('AIチャットのフィードバック保存中にエラーが発生しました。', e);
        } finally {
          this.isSubmittingReview = false;
        }
        await this.scrollToBottom();
      }
    };
  },
};
new LINCWELL.AI_CHAT();
